import { render, staticRenderFns } from "./WorksBulkEditingConfirmDialog.vue?vue&type=template&id=a5b98712"
import script from "./WorksBulkEditingConfirmDialog.vue?vue&type=script&lang=js"
export * from "./WorksBulkEditingConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports